import React, { useCallback } from 'react'

import { Container, CheckboxIcon } from './LabeledCheckbox.styles'

interface LabeledCheckboxProps {
  checked: boolean
  onSetChecked: (b: boolean) => any
  children?: any
}

export default function LabeledCheckbox({
  checked,
  onSetChecked,
  children,
  ...props
}: LabeledCheckboxProps) {
  return (
    <Container {...props}>
      <CheckboxIcon
        checked={checked}
        onClick={useCallback(() => onSetChecked(!checked), [
          onSetChecked,
          checked
        ])}
      />
      {children}
    </Container>
  )
}
